module.exports = __webpack_public_path__ + "static/media/techfy-logo-type.ace98357.png";